<template>
  <section id="payments" class="payments">
    <div class="container" data-aos="fade-up" v-if="getMobile && getAmount">
      <div class="section-title">
        <h2>Continue With a Payment Method</h2>
        <div class="row">
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('bkash')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/bkash.png" class="img-fluid" alt="bkash"/>
                <p>bKash</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('nagad')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/nagad.png" class="img-fluid" alt="nagad"/>
                <p>Nagad</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('rocket')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/rocket.png" class="img-fluid" alt="rocket"/>
                <p>Rocket</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('master')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/master.png" class="img-fluid" alt="gpsmall"/>
                <p>Master</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('visa')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/visa.png" class="img-fluid" alt="visa"/>
                <p>Visa</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 package" v-scroll-to="'#preview'" @click="selectPaymentMethod('nexus')">
            <div class="package-item">
              <div>
                <img src="assets/img/payments/nexus.png" class="img-fluid" alt="nexus"/>
                <p>Nexus Pay</p>
              </div>
              <div>
                <p class="price">{{ amount }} Tk.</p>
              </div>
            </div>
          </div>
        </div>
        <div id="preview"></div>
        <div class="row" v-if="getMethod && getMobile && getAmount">
          <div class="col-md-12 col-lg-12">
            <h3 class="review-payment">Review Payment Details</h3>
            <div class="row">
              <div class="offset-md-3"></div>
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tbody>
                  <tr>
                    <th>Topup Number</th>
                    <td>{{this.mobile}}</td>
                  </tr>
                  <tr>
                    <th>Connection Type</th>
                    <td>{{this.getConnectionType}}</td>
                  </tr>
                  <tr>
                    <th>Operator</th>
                    <td>{{this.operator}}</td>
                  </tr>
                  <tr>
                    <th>Amount</th>
                    <td>{{this.getTotalAmount}}</td>
                  </tr>
                  <tr>
                    <th>Payment Method</th>
                    <td>{{getMethod}}</td>
                  </tr>
                  </tbody>
                </table>
                <button class="btn btn-primary form-control payment-button" @click="proceedPayment">Proceed to Payment</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Skills Section -->
</template>

<script>
import axios from "axios";
export default {
  name: "PaymentOptions",
  data() {
    return {
      mobile: '',
      amount: 0,
      operator: '',
      type: '',
      uniqueNumber: ''
    }
  },
  created() {
    this.uniqueNumber = "wf"+Math.floor(Math.random() * 10000)+10;
  },
  computed: {
    getMobile() {
      return this.$store.state.mobile
    },
    getAmount() {
      return this.$store.state.amount
    },
    getConnectionType() {
      return this.$store.state.connectionType
    },
    getOperator() {
      return this.$store.state.operator
    },
    getMethod() {
      return this.$store.state.method
    },
    getTotalAmount() {
      return this.$store.state.totalAmount
    },
    getUser() {
      return this.$store.state.authUser
    }
  },
  mounted() {
    if (this.getMobile === "" || this.getAmount === "") {
      this.$router.push("/");
    } else {
      this.mobile = this.getMobile;
      this.amount = this.getAmount;
      this.type = this.getConnectionType;
      this.operator = this.getOperator;
    }
  },
  methods: {
    selectPaymentMethod(value) {
      let am = 0;
      let total = 0;
      const mnpPercent = 2.5;
      const cardPercent = 2.75;
      if (value === "bkash" || value === "nagad" || value === "rocket") {
        am = (parseInt(this.amount) * mnpPercent)/100;
        total = parseInt(this.amount);
        this.$store.commit('setTotalAmount',Math.round(total));
      } else {
        am = (parseInt(this.amount) * cardPercent)/100;
        total = parseInt(this.amount);
        this.$store.commit('setTotalAmount',Math.round(total));
      }
      this.$store.commit('setMethod',value)
    },
    proceedPayment() {
      localStorage.setItem('mobile',this.mobile);
      localStorage.setItem('operator',this.operator);
      localStorage.setItem('type',this.type);
      localStorage.setItem('amount',this.amount);
      localStorage.setItem('uId',this.uniqueNumber);
      localStorage.setItem('email',this.getUser.user_email);
      localStorage.setItem('payment_method',this.getMethod);
      let instance = this;
      axios.get(this.apiPath+'before-payment-process?email='+this.getUser.user_email+'&mobile='+this.mobile+'&operator='+this.operator+'&connection_type='+this.type+'&amount='+this.amount+'&uniqueId='+this.uniqueNumber+'&payment_method='+this.getMethod)
      .then(function (response){
        console.log(response.data);
        window.location.href = "https://svcwin.com/winpay/pm_req.aspx?clientID=winfin&uniqID="+instance.uniqueNumber+"&totalAmount="+instance.getTotalAmount+"&paymentOption="+instance.getMethod;
      }.bind()).catch(function (error){
        // instance.$toaster.error(error.response.data.message);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.payments img {
  width: 50px;
  height: 50px;
}

.payments {
  border-radius: 5px;
  padding-top: 120px;
  cursor: pointer;
  margin: 40px 5px;
}

.package {
  border: 1px solid #d3dee4;
  border-radius: 5px;
  margin: 0 5px 5px;
}

.package:hover {
  border: 1px solid #0062cc;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;
}

.package .package-item {
  padding: 15px 0;
}

.package-item p {
  font-size: 12px;
  font-weight: bold;
  float: right;
  letter-spacing: 0.05em;
}

.package-item .price {
  float: right;
  background: rgb(27, 118, 187);
  border-radius: 3px;
  padding: 1px 8px;
  color: #ffffff;
  margin: 5px 0;
}
.review-payment {
  margin: 30px 0;
}
.payment-button {
  font-weight: bold;
}
.table td {
  text-transform: capitalize;
}
button {
  background: #8F2D56;
  border: none;
}
button:hover {
  background: #004A59;
}
</style>
